require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-685943-bbbcaf-2-c-97-ea-6-a-9212.json") })
        }
      }, "path---blog-685943-bbbcaf-2-c-97-ea-6-a-9212");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-685943-bbbcaf-2-c-97-ea-6-a-9212!./.cache/json/blog-685943-bbbcaf-2-c-97-ea-6-a-9212.json
// module id = 409
// module chunks = 231608221292675